<template>
  <div class="state-fact-sheet" :class="{ 'is-loading': loading }">
    <div
      class="state-fact-sheet__frame"
      :class="{ 'is-clickable': currentDownloadUrl }"
      :style="{ height: frameHeight }"
      :role="currentDownloadUrl ? 'link' : null"
      :tabindex="currentDownloadUrl ? 0 : null"
      :aria-label="currentDownloadUrl ? downloadLabel : null"
      @click="open"
      @keydown.enter="open"
      ref="frame"
    >
      <div
        class="state-fact-sheet__scaler"
        :style="{ transform: 'scale(' + scale + ')', width: '612pt' }"
        ref="scaler"
      >
        <div v-if="html" v-html="html"></div>
        <slot v-else></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StateFactSheet",
  props: {
    stateCode: { type: String, default: "" },
    downloadUrl: { type: String, default: "" },
    downloadLabel: { type: String, default: "View the fact sheet" },
  },
  data: function () {
    return {
      scale: 1,
      frameHeight: "auto",
      observer: null,
      html: null,
      currentDownloadUrl: this.downloadUrl,
      loading: false,
      requestId: 0,
    };
  },
  methods: {
    open: function () {
      if (this.currentDownloadUrl) {
        window.open(this.currentDownloadUrl, "_blank", "noopener,noreferrer");
      }
    },
    resize: function () {
      var frame = this.$refs.frame;
      var scaler = this.$refs.scaler;
      if (!frame) return;
      var width = frame.clientWidth;
      if (width > 0) {
        this.scale = width / (612 * (4 / 3));
      }
      // After scaling, the frame height must match the scaled content height.
      this.$nextTick(this.updateHeight);
    },
    updateHeight: function () {
      var scaler = this.$refs.scaler;
      if (!scaler) return;
      this.frameHeight = Math.ceil(scaler.scrollHeight * this.scale) + "px";
    },
    onSelect: function (event) {
      var detail = event.detail || {};
      if (detail.stateCode !== this.stateCode) return;
      this.currentDownloadUrl = detail.downloadUrl || this.downloadUrl;
      this.load(detail.sheetUrl);
    },
    load: function (url) {
      if (!url) {
        this.html = null;
        this.$nextTick(this.updateHeight);
        return;
      }
      var self = this;
      var request = ++this.requestId;
      this.loading = true;

      fetch(url, { headers: { Accept: "text/html" } })
        .then(function (response) {
          return response.ok ? response.text() : Promise.reject(response.status);
        })
        .then(function (html) {
          if (request !== self.requestId) return;
          self.html = html;
          self.$nextTick(self.updateHeight);
        })
        .catch(function () {})
        .finally(function () {
          if (request === self.requestId) self.loading = false;
        });
    },
  },
  mounted: function () {
    this.resize();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(this.updateHeight);
    }
    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(this.resize);
      this.observer.observe(this.$refs.frame);
    } else {
      window.addEventListener("resize", this.resize);
    }
    window.addEventListener("state-fact-sheet:select", this.onSelect);
  },
  beforeDestroy: function () {
    if (this.observer) this.observer.disconnect();
    else window.removeEventListener("resize", this.resize);
    window.removeEventListener("state-fact-sheet:select", this.onSelect);
  },
};
</script>
